// @ts-ignore
/* eslint-disable */
import {
  adaptPageParams,
  adaptPageResult,
  apiProxy,
  apiUrl,
  IPageParams,
  IPageResult,
  getToken,
} from './index';
import { request } from '@umijs/max';

export async function fetchServerConfig() {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.serverConfigs}`, {
    method: 'GET',
  });
}

export async function fetchOpenConfig(key = '') {
  return request<Record<string, any>>(`/xfx-api/c/v1/config/_query/3/${key}`, {
    method: 'GET',
  });
}

export async function updateServerConfig(data: { id: string | number; [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.serverConfig(data?.key)}`, {
    method: 'PUT',
    data,
  });
}

export async function fetchNodeConfig(data: { id: string | number; [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.nodeConfig(data?.id)}`, {
    method: 'GET',
    data,
  });
}

export async function updateNodeConfig(data: { id: string | number; [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.nodeConfig(data?.id)}`, {
    method: 'PUT',
    data,
  });
}

export async function fetchNodeCache(data: { id: string | number; [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.nodeCache(data?.id)}`, {
    method: 'GET',
    data,
  });
}

export async function fetchNodes(params: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.aiServers}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function addNode(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.node()}`, {
    method: 'POST',
    ...(options || {}),
  });
}

export async function deleteNode(id: string | number) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.node(id)}`, {
    method: 'DELETE',
  });
}

export async function updateNode(data: { id: string | number; [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.node(data?.id)}`, {
    method: 'PUT',
    data,
  });
}

export async function authorizeNode(data: { id: string | number; [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.nodeAuthorize(data?.id)}`, {
    method: 'POST',
    data,
  });
}

export async function unAuthorizeNode(data: { id: string | number; [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.nodeUnAuthorize(data?.id)}`, {
    method: 'POST',
    data,
  });
}

export async function resetNode(data: { id: string | number; [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.nodeReset()}`, {
    method: 'POST',
    data,
  });
}

export async function fetchNodeStatus(data: { id: string | number; [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.nodeStatus(data?.id)}`, {
    method: 'GET',
    data,
    timeout: 10 * 1000,
    skipErrorHandler: true,
  });
}

export async function fetchCameraTroubles(params: {
  current?: number;
  pageSize?: number;
  [key: string]: any;
}): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.cameraTroubles}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function fetchDefaultEventTypes(params: {
  current?: number;
  pageSize?: number;
  [key: string]: any;
}): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.sceneDefaultEventTypes}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function fetchTroubleTypes(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.troubleTypes}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchTroubleUsers(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.troubleUsers}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchTroubleNodes(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.troubleNodes}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchShootTroubles(params: {
  current?: number;
  pageSize?: number;
  [key: string]: any;
}): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.shootTroubles}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function batchTroubles(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.troubleBatch}`, {
    method: 'PUT',
    ...(options || {}),
  });
}

export async function exportTroubles(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.troubleExport}`, {
    method: 'POST',
    responseType: 'blob',
    getResponse: true,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    ...(options || {}),
  });
}

export async function fetchTroublePing(id = '') {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.troublePing(id)}`, {
    method: 'GET',
  });
}

export async function fetchTrouble(id = '') {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.trouble(id)}`, {
    method: 'GET',
  });
}

export async function updateTrouble(id = '', options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.trouble(id)}`, {
    method: 'PUT',
    ...(options || {}),
  });
}

export async function fetchFaceLib(params: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.faceLib}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function addFaceMember(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.faceMember()}`, {
    method: 'POST',
    ...(options || {}),
  });
}

export async function deleteFaceMember(id: string | number) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.faceMember(id)}`, {
    method: 'DELETE',
  });
}

export async function updateFaceMember(id: string | number = '', options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.faceMember(id)}`, {
    method: 'PUT',
    ...(options || {}),
  });
}

export async function uploadFacePhoto({ id, photoId, ...options }: { [key: string]: any } = {}) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.facePhoto(id, photoId)}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'multipart/form-data;charset=UTF-8',
    },
    ...(options || {}),
  });
}

export async function deleteFacePhoto({ id, photoId, ...options }: { [key: string]: any } = {}) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.facePhoto(id, photoId)}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}
